import React, { Component, useEffect, useState } from "react";
import Base64ImageRender from "../../common/Base64ImageRender";

import Loadspinner from "../../common/Loadspinner";
import Main from "../../common/Main/Main";

import * as images from "../../constants/Images";
import ProfileService from "../../services/ProfileService";
import AddExpertise from "./AddExpertise";
import AddInterests from "./AddInterests";
import "./Profile.css";

const ProfileNew = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [interests, setInterests] = useState([]);
  const [interestLength, setInterestLength] = useState(0);
  const [expertise, setExpertise] = useState([]);
  const [expertiseLength, setExpertiseLength] = useState(0);

  useEffect(() => {
    getInterestsList();
  }, []);

  const getInterestsList = async () => {
    setIsLoading(true);
    const res = await ProfileService.getInterests();
    if (res) {
      let { userInterestList, userExpertiseList } = res;
      setInterests(userInterestList);
      setInterestLength(userInterestList.length);
      setExpertise(userExpertiseList);
      setExpertiseLength(userExpertiseList.length);
    }
    setIsLoading(false);
  };

  const rerender = () => {
    getInterestsList();
  };

  return (
    <Main active={null} interestLength={interestLength}>
      <Loadspinner filename="ProfileNew.js" isLoading={isLoading} isMiddle="false" />
      <div className="container">
        <h4 style={{ marginTop: '15px' }}>EDIT PROFILE</h4>
        <div className=" display-row">
          <div className="display-column">
            <div className=" card profile-card display-row justify-space-between profile-card-header">
              <img
                src={images.interests}
                className="profile-card-header-img"
              />

              <h6 style={{ color: "white" }}>
                My Interests({interestLength})
              </h6>
              <AddInterests updated={rerender} selected={interests} />
            </div>
            {interestLength == 0 ? (
              <div className="card profile-card">
                <p>You have not added any interests</p>
              </div>
            ) : (
              interests.map((interest) => (
                <div
                  className="card profile-card display-row "
                  key={interest.id}
                >
                  {/* <img
                      src={interest.system_image}
                      className="profile-card-icon"
                    /> */}
                  <Base64ImageRender url={interest.system_image} />
                  <p style={{ alignSelf: "center" }}>
                    {interest.system_desc}
                  </p>
                </div>
              ))
            )}
          </div>
          <div className="display-column">
            <div className=" card profile-card display-row justify-space-between profile-card-header">
              <img
                src={images.expertise}
                className="profile-card-header-img"
              />

              <h6 style={{ color: "white" }}>
                My Expertise({expertiseLength})
              </h6>
              <AddExpertise updated={rerender} selected={expertise} />
            </div>
            {expertiseLength == 0 ? (
              <div className="card profile-card">
                <p>You have not added any area of expertise</p>
              </div>
            ) : (
              expertise.map((exp) => (
                <div className="card profile-card display-row "
                  key={exp.id}>
                  {/* <img src={exp.system_image} className="profile-card-icon" /> */}
                  <Base64ImageRender url={exp.system_image} />
                  <p style={{ alignSelf: 'center' }}>{exp.system_desc}</p>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </Main>
  );
}

export default ProfileNew;
